<div>
  <img class="image" [src]="imageUrl | safe: 'resourceUrl'" />
</div>
